import application from "./media/illustrations/application.svg";
import search from "./media/illustrations/search.svg";
import support from "./media/illustrations/support.svg";
import viewing from "./media/illustrations/viewing.svg";

interface HomeHeroImgType {
  src: string;
  alt: string;
}

interface LogoType {
  light: string;
  dark: string;
}

interface QualificationLogoType {
  propertymark: string;
  cmp: string;
  prs: string;
  dps: string;
}

interface RentIllustrationType {
  application: string;
  search: string;
  support: string;
  viewing: string;
}

interface PropertiesImgType {
  mount: string;
  millbank6200: string;
  moor17117: string;
  moor15000: string;
  one3300: string;
  one4200: string;
  one4500: string;
  one3700: string;
  millbank6000: string;
  markville: string;
  blackfriars: string;
  parrs: string;
  blenheim: string;
  allium: string;
  bentinck: string;
  lincoln: string;
  thenova: string;
  studiowhitecity: string;
  blackfriars3200: string;
  clunymews4200: string;
  legacy: string;
  copse: string;
  allium1730: string;
  clunymews3200: string;
  salutation: string;
  jubilee3000: string;
  jubilee3300: string;
  parkside: string;
  basil: string;
  dingley: string;
  mountpleasant: string;
  jubileewalk3500: string;
  jubileewalk3300: string;
  viaductgardens4333: string;
  viaductgardens4500: string;
  marshwall: string;
  paragonsquare: string;
  paragonsquare5000: string;
  sunstreet: string;
  coster: string;
  panpeninsula: string;
  millbank60002: string;
  jubilee3500: string;
  hemlock: string;
  clunymews4500: string;
  clunymews3500: string;
  conquest: string;
  onetheelephant: string;
  darter: string;
  empire: string;
  blackfriars3000: string;
  darter2350: string;
  handley: string;
  harcourt: string;
  oncleveland: string;
  hartingtons: string;
  kidbrookevillageblackheath: string;
  damactower9966: string;
  ovalvillage3800: string;
  ovalvillage2800: string;
  ovalvillage2900: string;
  parkdrive3042: string;
  chenistongarden24999: string;
  lincolnsquare6656: string;
  woodberrydown1650: string;
  damac0210: string;
  oval02103800: string;
  oval02102800: string;
  cheniston0210: string;
  fairbourne0210: string;
  watkin0210: string;
  albany0210: string;
  union0210: string;
  kidbrooke0210: string;
  cluny0210: string;
  onezero0210: string;
  rw90jch: string;
  rw90ih: string;
  opus0224: string;
  watkin0224: string;
  edenplace0403: string;
  gasholder0403: string;
  londondock0508: string;
  parkside0508: string;
  cluny0508: string;
  signature0508: string;
  dingley0508: string;
  conquestTower0813: string;
  dumont0813: string;
  embassy0813: string;
  embassy08132: string;
  harcourtTower0813: string;
  oneThamesQuay0813: string;
  truro0813: string;
  westernCircus0813: string;
  one0826: string;
  markville0826: string;
  brunswick0826: string;
  oval0826: string;
  albright0826: string;
  john1006: string;
  heron1208: string;
  garraway1208: string;
  conquest1208: string;
  warwick1208: string;
}

export const homeHeroImg: HomeHeroImgType[] = [
  { src: "", alt: "" },
  { src: "", alt: "" },
  { src: "", alt: "" },
];

export const logo: LogoType = {
  light: require("./media/logo/letting-engine-logo-light.png"),
  dark: require("./media/logo/letting-engine-logo-dark.png"),
};

const CDN_FILE_BASE = "https://cdn.lettingengine.com/file";

export const lettingProcedure: string = `${CDN_FILE_BASE}/2026+Letting+Engine+Landlord+Fees+and+Charges+-+EN.pdf`;
export const lettingVacant: string = require("./document/LE VACANT PROPERTY MANAGEMENT PRICE LIST.pdf");
export const cmpCertificate: string = require("./document/New Vision Real Estate Ltd- CMP Ceritificate -31072026.pdf");
export const propertymarkCertificate: string = `${CDN_FILE_BASE}/Propertymark%C2%A0Certificate%C2%A0-%C2%A0New%C2%A0Vision%C2%A0Real%C2%A0Estate%C2%A0Ltd.pdf`;
export const prsCertificate: string = `${CDN_FILE_BASE}/PRS+Certificate.pdf`;
export const londonAreaGuideCentral: string = require("./document/Letting Engine - London Area Guide - Central.pdf");

export const qualificationLogo: QualificationLogoType = {
  propertymark: require("./media/logo/qualification/propertymark.png"),
  cmp: require("./media/logo/qualification/cmp.png"),
  prs: require("./media/logo/qualification/prs.png"),
  dps: require("./media/logo/qualification/dps.png"),
};

export const backgroundImg: any = {
  livingRoom1: require("./media/background/living-room1.jpg"),
  livingRoom2: require("./media/background/living-room2.jpg"),
  livingRoom3: require("./media/background/living-room3.jpg"),
  livingRoom5: require("./media/background/living-room5.jpg"),
  livingRoom4: require("./media/background/living-room4.jpg"),
  meeting1: require("./media/background/meeting1.jpg"),
  social: require("./media/background/social-event.jpg"),
  meeting2: require("./media/background/meeting2.jpg"),
  london: require("./media/background/london.jpg"),
};

export const rentIllustration: RentIllustrationType = {
  application: application,
  search: search,
  support: support,
  viewing: viewing,
};

export const propertiesImg: PropertiesImgType = {
  mount: require("./media/property/8mount.jpeg"),
  millbank6200: require("./media/property/millbank6200.jpeg"),
  moor17117: require("./media/property/moor17117.jpeg"),
  moor15000: require("./media/property/moor15000.jpeg"),
  one3300: require("./media/property/one3300.jpeg"),
  one4200: require("./media/property/one4200.jpeg"),
  one4500: require("./media/property/one4500.jpeg"),
  one3700: require("./media/property/one3700.jpeg"),
  millbank6000: require("./media/property/millbank6000.jpeg"),
  markville: require("./media/property/markville.jpeg"),
  blackfriars: require("./media/property/blackfriars.jpeg"),
  parrs: require("./media/property/parrs.jpeg"),
  blenheim: require("./media/property/blenheim.jpeg"),
  allium: require("./media/property/allium.jpeg"),
  bentinck: require("./media/property/bentinck.jpeg"),
  lincoln: require("./media/property/lincoln.jpeg"),
  thenova: require("./media/property/thenova.jpeg"),
  studiowhitecity: require("./media/property/studiowhitecity.jpeg"),
  blackfriars3200: require("./media/property/blackfriars3200.jpeg"),
  clunymews4200: require("./media/property/3clunymews4200.jpeg"),
  legacy: require("./media/property/legacy.jpeg"),
  copse: require("./media/property/39copse.jpeg"),
  allium1730: require("./media/property/allium1730.jpeg"),
  clunymews3200: require("./media/property/clunymews3200.jpeg"),
  salutation: require("./media/property/salutation.jpeg"),
  jubilee3000: require("./media/property/jubilee3000.jpeg"),
  jubilee3300: require("./media/property/jubilee3300.jpeg"),
  parkside: require("./media/property/parkside.jpeg"),
  basil: require("./media/property/basil.jpeg"),
  dingley: require("./media/property/dingley.jpeg"),
  mountpleasant: require("./media/property/mountpleasant.jpeg"),
  jubileewalk3500: require("./media/property/jubileewalk3500.jpeg"),
  jubileewalk3300: require("./media/property/jubileewalk3300.jpeg"),
  viaductgardens4333: require("./media/property/viaductgardens4333.jpeg"),
  viaductgardens4500: require("./media/property/viaductgardens4500.jpeg"),
  marshwall: require("./media/property/marshwall.jpeg"),
  paragonsquare: require("./media/property/paragonsquare.jpeg"),
  paragonsquare5000: require("./media/property/paragonsquare5000.jpeg"),
  sunstreet: require("./media/property/sunstreet.jpeg"),
  coster: require("./media/property/coster.jpeg"),
  panpeninsula: require("./media/property/panpeninsula.jpeg"),
  millbank60002: require("./media/property/millbank60002.jpeg"),
  jubilee3500: require("./media/property/jubilee3500.jpeg"),
  hemlock: require("./media/property/hemlock.jpeg"),
  clunymews4500: require("./media/property/clunymews4500.jpeg"),
  clunymews3500: require("./media/property/clunymews3500.jpeg"),
  conquest: require("./media/property/conquest.jpeg"),
  onetheelephant: require("./media/property/one-the-elephant.jpeg"),
  darter: require("./media/property/darter.jpeg"),
  empire: require("./media/property/empire.jpeg"),
  blackfriars3000: require("./media/property/blackfriars3000.jpeg"),
  darter2350: require("./media/property/darter2350.jpeg"),
  handley: require("./media/property/handley.jpeg"),
  harcourt: require("./media/property/harcourt.jpeg"),
  oncleveland: require("./media/property/oncleveland.jpeg"),
  hartingtons: require("./media/property/hartingtons.jpeg"),
  kidbrookevillageblackheath: require("./media/property/kidbrookevillageblackheath.jpeg"),
  damactower9966: require("./media/property/damactower9966.jpeg"),
  ovalvillage3800: require("./media/property/ovalvillage3800.jpeg"),
  ovalvillage2800: require("./media/property/ovalvillage2800.jpeg"),
  ovalvillage2900: require("./media/property/ovalvillage2900.jpeg"),
  parkdrive3042: require("./media/property/parkdrive3042.jpeg"),
  chenistongarden24999: require("./media/property/chenistongarden24999.jpeg"),
  lincolnsquare6656: require("./media/property/lincolnsquare6656.jpeg"),
  woodberrydown1650: require("./media/property/woodberrydown1650.jpeg"),
  damac0210: require("./media/property/damac0210.jpeg"),
  oval02103800: require("./media/property/oval02103800.jpeg"),
  oval02102800: require("./media/property/oval02102800.jpeg"),
  cheniston0210: require("./media/property/cheniston0210.jpeg"),
  fairbourne0210: require("./media/property/fairbourne0210.jpeg"),
  watkin0210: require("./media/property/watkin0210.jpeg"),
  albany0210: require("./media/property/albany0210.jpeg"),
  union0210: require("./media/property/union0210.jpeg"),
  kidbrooke0210: require("./media/property/kidbrooke0210.jpeg"),
  cluny0210: require("./media/property/cluny0210.jpeg"),
  onezero0210: require("./media/property/onezero0210.jpeg"),
  rw90jch: require("./media/property/rw90jch.jpeg"),
  rw90ih: require("./media/property/rw90ih.jpeg"),
  opus0224: require("./media/property/opus0224.jpeg"),
  watkin0224: require("./media/property/watkin0224.jpeg"),
  edenplace0403: require("./media/property/edenplace0403.jpeg"),
  gasholder0403: require("./media/property/gasholder0403.jpeg"),
  londondock0508: require("./media/property/londondock0508.jpeg"),
  parkside0508: require("./media/property/parkside0508.jpeg"),
  cluny0508: require("./media/property/clunymews0508.jpeg"),
  signature0508: require("./media/property/signature0508.jpeg"),
  dingley0508: require("./media/property/dingley0508.jpeg"),
  conquestTower0813: require("./media/property/conquestTower0813.jpeg"),
  dumont0813: require("./media/property/dumont0813.jpeg"),
  embassy0813: require("./media/property/embassy0813.jpeg"),
  embassy08132: require("./media/property/embassy08132.jpeg"),
  harcourtTower0813: require("./media/property/harcourtTower0813.jpeg"),
  oneThamesQuay0813: require("./media/property/oneThamesQuay0813.jpeg"),
  truro0813: require("./media/property/truro0813.jpeg"),
  westernCircus0813: require("./media/property/westernCircus0813.jpeg"),
  one0826: require("./media/property/one0826.jpeg"),
  markville0826: require("./media/property/markville0826.jpeg"),
  brunswick0826: require("./media/property/brunswick0826.jpeg"),
  oval0826: require("./media/property/oval0826.jpeg"),
  albright0826: require("./media/property/albright0826.jpeg"),
  john1006: require("./media/property/john1006.jpeg"),
  heron1208: require("./media/property/heron1208.jpeg"),
  garraway1208: require("./media/property/garraway1208.jpeg"),
  conquest1208: require("./media/property/conquest1208.jpeg"),
  warwick1208: require("./media/property/warwick1208.jpeg"),
};
